import React, { Component } from 'react';
import Helmet from "react-helmet";
import { lang } from '../../../il8n/lang';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Link } from "react-router-dom";


import Caro from '../../Carousels/Caro/Caro';


import GeneralModal from '../../GeneralModal/GeneralModal';
import VideoPlayer from '../../VideoPlayer/VideoPlayer';




import Spritesheet from 'react-responsive-spritesheet';

import { cdnBase, breakSmall } from '../../../const';
import _ from 'lodash';






import { toggleInterstitial, changeActiveAudio } from '../../../Actions/Index';

import '../../../hover-min.css';
import './Home.css';

/**
 * Home
 * @constructor
 */

class Home extends Component {
  constructor(props){
    super(props);
    this.state = {
      modalOpen: false,
      musicToggle: false,
      bgImg: window.innerWidth < breakSmall ? 'bgImg-mobile' : 'bgImg',
      appCaroItem: window.innerWidth < breakSmall ? 'img_mobile' : 'img',
      lastScrollTop: 0,
      trainflip: false,
      activeClass: 'active',
      fadedStatus: [false, false, false],
      toast: window.innerWidth < breakSmall ?  false : true
      // currentAudio: `${cdnBase}commingsoon/Mighty+Express+Theme+-+Band+Only.wav`
    };

    this.toggleModal = this.toggleModal.bind(this);
    // this.handleMusicToggle = this.handleMusicToggle.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.setfades = this.setfades.bind(this);


    // this.url = `${cdnBase}commingsoon/Mighty+Express+Theme+-+Band+Only.wav`;
    // console.log('currentAudio',  this.props, this.state)
    this.audio = new Audio(this.state.currentAudio);
    this.audio.loop = true;

    this.spritesheeInstance = lang.home.trainProps;



  }

  componentDidMount(){

    this.timeoutId = setTimeout(function () {
      this.setState({toast: true});
    }.bind(this), 1000);

    window.addEventListener('resize', this.onResize, false);
    this.throttledResize = _.throttle(this.throttledResize.bind(this), 500);
    this.props.dispatch(toggleInterstitial(false, '', ''));
    


    const height = document.getElementById('home').clientHeight;
    this.setState({ height });

    window.addEventListener('scroll', this.handleScroll);

    let elHeight = document.getElementById('story').clientHeight;
    this.setState({avgSecHeight: elHeight});

    // let trainProps = lang.home.trainProps.map(prop=>({...prop,autoPlay:false}))
    let trainProps = lang.home.trainProps;
    
    trainProps.forEach((group)=>{
      group.props.map(
        prop=>({...prop,instance: {} })
      )
    })
    // let trainProps = lang.home.trainProps.forEach(
    //   group=>(
    //     group.props.map(
    //       prop=>({...prop,autoPlay:false})
    //     )
    //   )
    // );
    // console.log('compoonent did mount',trainProps,  lang.home.trainProps)

    this.setState({trainProps: trainProps})

    this.setfades()

  }

  componentWillUnmount(){
    if (this.timeoutId) {
        clearTimeout(this.timeoutId);
    }
    window.removeEventListener('resize', this.onResize, false);
    window.removeEventListener('scroll', this.handleScroll);

  }


  setfades(){
    // console.log('fade os set')
    let supportPageOffset = window.pageXOffset !== undefined;
    let isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');
    const currentScrollTop = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;

    const docheight = document.documentElement.offsetHeight - window.innerHeight;
    const docScrollPercent = Math.floor(((currentScrollTop )/docheight)*100 );

    let scrollPercent = 0;

    const trainWidth = 200;
    let heights = [];
    let sections = document.getElementsByClassName("section");

    let getCurrentPercent = ()=>{
      let currentStops = [];
      // console.log( heights)
      
      heights.forEach((height, hI)=>{
        if(hI!== heights.length && currentScrollTop > height && currentScrollTop < heights[hI+1]){
          currentStops = [height,heights[hI+1]];

          scrollPercent = Math.floor( ((currentScrollTop-currentStops[0])/(currentStops[1]-currentStops[0]))*100 )

        }else if(hI!== heights.length && currentScrollTop > height && currentScrollTop < docheight ){
          currentStops = [height,docheight];
          scrollPercent = Math.floor( ((currentScrollTop-currentStops[0])/(currentStops[1]-currentStops[0]))*100 )
        }
      })
      

    }
    getCurrentPercent();


    if(currentScrollTop > 200 && docScrollPercent < 97){
      this.setState({pastFold: true})
    }else{
      this.setState({pastFold: false})
    }


    Array.from(sections).forEach(section => {
      heights.push(section.offsetTop)
    });
    heights.forEach((height, hI)=>{

      if( hI !== heights.length-1 && (currentScrollTop > (height - window.innerHeight) ) ){
        let fadedStatus = this.state.fadedStatus;
        let index = hI - 1;
        fadedStatus[index] = true;
        this.setState({fadedStatus: fadedStatus})


      }
    })

  }


  /**
  * handle scroll
  * @param {event} event
  */

  handleScroll(e) {
    // this.props.dispatch(changeActiveAudio( `${cdnBase}tracksville/104B+Nate+and+Max+Travelling+Cue+-+BQ100.wav`))

    // We only change the state if it needs to be changed
    let supportPageOffset = window.pageXOffset !== undefined;
    let isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');
    const currentScrollTop = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;

    const docheight = document.documentElement.offsetHeight - window.innerHeight;
    const docScrollPercent = Math.floor(((currentScrollTop )/docheight)*100 );

    let scrollPercent = 0;

    const trainWidth = 200;

    // const avgSecHeight = this.state.avgSecHeight;
    let heights = [];
    let sections = document.getElementsByClassName("section");
    // console.log(heights, sections)

    Array.from(sections).forEach(section => {
      heights.push(section.offsetTop)
    });

    let getCurrentPercent = ()=>{
      let currentStops = [];
      // console.log( heights)
      
      heights.forEach((height, hI)=>{
        if(hI!== heights.length && currentScrollTop > height && currentScrollTop < heights[hI+1]){
          currentStops = [height,heights[hI+1]];

          scrollPercent = Math.floor( ((currentScrollTop-currentStops[0])/(currentStops[1]-currentStops[0]))*100 )

        }else if(hI!== heights.length && currentScrollTop > height && currentScrollTop < docheight ){
          currentStops = [height,docheight];
          scrollPercent = Math.floor( ((currentScrollTop-currentStops[0])/(currentStops[1]-currentStops[0]))*100 )
        }
      })
      

    }
    getCurrentPercent();
    const widthPixels = (scrollPercent/100)*(window.innerWidth+trainWidth);
    const fullWidthPixels = (docScrollPercent/100)*((window.innerWidth+trainWidth)*6);
    // const fullWidthPixels = (docScrollPercent/100)*((window.innerWidth+trainWidth)*4.5);

    // 0.75

    if(currentScrollTop > 200 && docScrollPercent < 97){
      this.setState({pastFold: true})
    }else{
      this.setState({pastFold: false})
    }
    if (currentScrollTop > this.state.lastScrollTop) {
      this.setState({trainflip: false});
    } else {
      this.setState({trainflip: true});
    }

    

    this.setState({ trainScrollPercent: widthPixels, propsScrollPercent: fullWidthPixels,  lastScrollTop: currentScrollTop });

    let trainProps = this.state.trainProps;


    // if(trainProps){
      trainProps.forEach((group) => {
        // console.log(group)
        group.props.forEach((prop) => {
          if(document.getElementById('prop__'+prop.id)){
            let leftPos = document.getElementById('prop__'+prop.id).getBoundingClientRect().left;
            // if(prop.id === 4){
            //   // console.log('leftPos ',leftPos, this.state.trainScrollPercent)
            // }
            
            if((leftPos - 200) < this.state.trainScrollPercent && (leftPos + 400) > this.state.trainScrollPercent){
              if(prop.instance){
                prop.instance.play();
              }
    
            }else{
    
              if(prop.instance){
                prop.instance.goToAndPause(1);
              }
            }
          }
        })
      });
    // }

    heights.forEach((height, hI)=>{
      if( hI !== heights.length-1 && (currentScrollTop > (height - window.innerHeight) && currentScrollTop < heights[hI+1] - window.innerHeight) ){
        let fadedStatus = this.state.fadedStatus;
        let index = hI - 1;
        fadedStatus[index] = true;
        this.setState({fadedStatus: fadedStatus})


      }
    })

  

  }
  spriteInstance(instance,groupindex,index){
    if(this.state.trainProps){
      let trainProps = this.state.trainProps;
      trainProps[groupindex].props[index].instance = instance;
      this.setState({trainProps: trainProps})
      // console.log(this.state.trainProps)
    }else{
      console.log('ERROR')
      
    }
  }

  // play(){
  //   this.setState({
  //     play: true,
  //     pause: false
  //   });
  //   // console.log(this.audio);
  //   this.audio.play();
  // }

  // pause(){
  //   this.setState({ play: false, pause: true });
  //   this.audio.pause();
  // }

  

  /**
  * Tied to the resize event on window
  */
  onResize = (e) => {
    this.throttledResize(e);
  }
  /**
  * Throttled resize function, handles resetting slidesToShow count
  */
  throttledResize = (e) => {
    let elHeight = document.getElementById('story').clientHeight;
    this.setState({avgSecHeight: elHeight});

    this.setState({
      bgImg: window.innerWidth < breakSmall ? 'commingsoon/Background/ComingSoonBG_mobile.jpg' : 'commingsoon/Background/ComingSoonBG_desktop.jpg'
    });
    this.setState({
      appCaroItem: window.innerWidth < breakSmall ?  'img_mobile' : 'img'
    });

    this.setState({
      toast: window.innerWidth < breakSmall ?  false : true
    });
  }

  // handleMusicToggle(){
  //   this.setState({musicToggle: !this.state.musicToggle});
  //   if(this.state.musicToggle){
  //     this.audio.pause();
  //   }else{
  //     this.audio.play();
  //   }
  // }

  toggleModal(vid){
    this.props.dispatch(changeActiveAudio(`${cdnBase}commingsoon/Mighty+Express+Theme+-+Band+Only.wav`, false));

    this.setState(state => ({
      modalOpen: !state.modalOpen,
      currentvid: vid
    }));
  }
  
  renderTrainProps(){

  }
  
  render() {
    let {gaToggle} = this.props;

    return (
      <div>
        <Helmet title={ lang.home.title + lang.helmet.siteTitle } />
        <GeneralModal open={this.state.modalOpen} toggleModal={this.toggleModal}>
          <VideoPlayer
            type={'default'}
            activeVid={this.state.currentvid}
            warn={lang.warnings.enableIframes}
            autoPlay={true}
            loop = {false}

          />
        </GeneralModal>
        {/* <div className="musicToggle" onClick={()=>this.handleMusicToggle()}>
          {!this.state.musicToggle && (
            <div className="musicToggle__wrapper mod-off">
              <div className="musicToggle__icon"><img src={`${cdnBase}commingsoon/Buttons+%2B+Icons/music_on.svg`} /></div>

              <div><b>music<br/>on</b></div>
            </div>
          )}
          {this.state.musicToggle && (
            <div className="musicToggle__wrapper mod-on">
              <div className="musicToggle__icon"><img src={`${cdnBase}commingsoon/Buttons+%2B+Icons/music_off.svg`} /></div>

              <div><b>music<br/>off</b></div>
            </div>
          )}
        </div> */}
        
        <div className="home" id="home"> 
          {lang.home.sections.allaboard &&(
            <div className="section allaboard section--bgImg" style={{'backgroundImage': `url(${cdnBase}header/homepage_BG_mobile.jpg)`}}>
              {lang.home.sections.allaboard.toast && (
                <Link className={`toast ${this.state.toast ? 'popin' : null}`} to={`/${lang.getLanguage()}/toys`}>
                  <img src={`${cdnBase}sept+2021/toast-train.png`} alt="train toy"></img>
                  <span>{lang.home.sections.allaboard.toast}</span>
                </Link>
              )}
              
              <div className="section__bg section__bg--darken" >
                <div className="section__bg__img  mobileonly">
                  <img src={`${cdnBase}header/homepage_TRAINS_mobile.png`} alt="trains"></img>
                </div>
                <div className="section__bg__video desktoponly">
                  <video src={lang.home.sections.allaboard.vid} poster={`${cdnBase}header/homepage_BG_mobile.jpg`} loop autoPlay muted></video>
                </div>
              </div>
              <Grid fluid className="section__fg"   center="lg">
                <Row center="lg" middle="lg" className="section__fg__center home__headerContent">

                    {/* <div className="biglogo"> */}
                      <img className="biglogo" src={`${cdnBase}commingsoon/Logos/mightyexpress_logoTM.png`} alt={`mighty express`}></img>
                    {/* </div> */}


                  <h1>{lang.home.sections.allaboard.header1}<br></br>{lang.home.sections.allaboard.header2}</h1>
                  {/* <Row center="sm"> */}
                    <button className="hvr-pop" onClick={()=>this.toggleModal(lang.home.sections.allaboard.cta1.link)}>
                      <img className="playicon__static" src={`${cdnBase}universal/play-icon-for-button.svg`} alt="play"></img>
                      <img className="playicon__hover" src={`${cdnBase}header/play-icon-for-button-hover.svg`} alt="play"></img>
                      

                      {lang.home.sections.allaboard.cta1.copy}
                    </button>
                  {/* </Row> */}
                  <img className="pawpatrol" src={`${cdnBase}header/PawApprovedBadge-Blue.png`} alt={`paw patrol and friends`}></img>
                  <img className="smallarrow" src={`${cdnBase}scroll-down-arrow-icon.svg`} alt={'down arrow'}/>


                  

                </Row>
              </Grid>
  
            </div>
          )}
          {lang.home.sections.toystation &&(
            <div className="section section--bgImg toystation section--belowfold" id="toystation" style={{'backgroundImage': `url(${lang.home.sections.toystation.bgImg})`}}>
              <Grid fluid className="section__fg" middle="lg"  center="lg">
                <Row middle="lg">
                  <Col lg={4} center="lg"  middle="lg" className={`borderedBox ${this.state.fadedStatus[0] ? 'active':''}`}>
                    <h1>{lang.home.sections.toystation.header}</h1>
                    <p>{lang.home.sections.toystation.copy}</p>
                    {/* <Row>
                      <button className="hvr-pop">{lang.home.sections.toystation.cta1.copy}</button>
                    </Row> */}
                    <Row>
                      <a href={`/${lang.getLanguage()}${lang.home.sections.toystation.cta2.link}`}>
                        <button className="hvr-pop">{lang.home.sections.toystation.cta2.copy}</button>
                      </a>
                    </Row>
                  </Col>
                </Row>
                
                <Row  middle="lg" className="mobileImg mobileonly" >
                  <img src={lang.home.sections.toystation.mobileBgImg } alt="bg img"></img>
                </Row>
              </Grid>

            </div>
          )}
          {lang.home.sections.story &&(
            <div className="section section--bgImg story section--belowfold" id="story" style={{'backgroundImage': `url(${lang.home.sections.story.bgImg})`}}>
              <Grid fluid className="section__fg" middle="lg"  center="lg">
                <Row middle="lg">
                  <Col lg={5} center="lg"  middle="lg" className={`borderedBox ${this.state.fadedStatus[0] ? 'active':''}`}>
                    <h1>{lang.home.sections.story.header}</h1>
                    <p>{lang.home.sections.story.copy}</p>
                    <strong>{lang.home.sections.story.subcopy}</strong>

                  </Col>
                </Row>
                
                <Row  middle="lg" className="mobileImg mobileonly" >
                  <img src={lang.home.sections.story.mobileFgImg} alt={'bg img'}></img>
                </Row>
              </Grid>

            </div>
          )}
          {lang.home.sections.characters &&(
            <div className="section section--bgImg characters section--belowfold" style={{'backgroundImage': `url(${lang.home.sections.characters.bgImg})`}}>
              <Grid fluid className="section__fg" middle="lg"  center="lg">
                
                <Row end="lg" middle="lg" className="section__fg__content">
                  <Col lg={4} center="lg"  middle="lg" className={`borderedBox ${this.state.fadedStatus[1] ? 'active':''}`}>

                    <h1>{lang.home.sections.characters.header}</h1>
                    <p>{lang.home.sections.characters.copy}</p>
                    <a href={`/${lang.getLanguage()}${lang.home.sections.characters.cta.link}`}>
                      <button className="hvr-pop">{lang.home.sections.characters.cta.copy}</button>
                    </a>

                  </Col>
                </Row>
                <Row  middle="lg" className="mobileImg mobileonly" >
                  <img src={lang.home.sections.characters.mobileFgImg} alt={'bg img'}></img>
                </Row>
                
              </Grid>
            </div>
          )}

          {lang.home.sections.printables &&(
            <div className="section section--bgImg printables section--belowfold" style={{'backgroundImage': `url(${lang.home.sections.printables.bgImg})`}}>
              <Grid fluid className="section__fg" middle="lg"  center="lg">
                <Row  middle="lg">
                  <Col lg={5}  middle="lg" className={`borderedBox ${this.state.fadedStatus[2] ? 'active':''}`}>

                    <h1>{lang.home.sections.printables.header}</h1>
                    <p>{lang.home.sections.printables.copy}</p>
                    <a href={`/${lang.getLanguage()}${lang.home.sections.printables.cta.link}`}>
                      <button className="hvr-pop">{lang.home.sections.printables.cta.copy}</button>
                    </a>

                  </Col>
                </Row>
                <Row  middle="lg" className="mobileImg mobileonly">
                  <img src={lang.home.sections.printables.mobileFgImg} alt={"bg img"}></img>
                </Row>
              </Grid>
            </div>
          )}
          {lang.home.sections.watch &&(
            <div className="section section--bgImg watch" id="wheretowatch" style={{'backgroundImage': `url(${lang.home.sections.watch.bgImg})`}}>
              <Grid fluid className="section__fg" middle="lg"  center="lg">
                <Row center="lg" middle="lg">
                  <Col sm={6} center={"lg" } middle="lg">
                    <h1>{lang.home.sections.watch.header}<br></br>{lang.home.sections.watch.header2}</h1>
                    <Row  middle="lg" center={"lg"}>
                      {/* <a onClick={()=>this.props.dispatch(toggleInterstitial(true, lang.home.sections.watch.cta1.link ))} target="_blank" rel="noreferrer noopener"> */}
                        <img className={lang.home.sections.watch.cta1.alt}  src={lang.home.sections.watch.cta1.img} alt={lang.home.sections.watch.cta1.alt}></img>
                      {/* </a> */}
                    </Row>
                    <Row  middle="lg" center={"lg"}>
                      <a 
                        onClick={()=>this.props.dispatch(toggleInterstitial(true, lang.home.sections.watch.cta2.link ))}  
                        target="_blank" 
                        rel="noreferrer noopener"
                        className="hvr-pop"
                      >
                        <img className={lang.home.sections.watch.cta2.alt} src={lang.home.sections.watch.cta2.img} alt={lang.home.sections.watch.cta2.alt}></img>
                      </a>
                    </Row>
                  </Col>
                </Row>
              </Grid>
            </div>
          )}
          {lang.home.sections.app &&(
            <div className="section section--bgImg app section--belowfold" id="app" style={{'backgroundImage': `url(${lang.home.sections.app.bgImg})`}}>
              <Grid fluid className="section__fg" middle="lg"  center="lg">
                <Row center="lg" middle="lg" >
                  <Col lg={10} className={`borderedBox ${this.state.fadedStatus[3] ? 'active':''}`} >
                    <Row center="lg" middle="lg">
                      <Col lg={4} start="xs">
                          <Row className="app__copy">
                          <h1>{lang.home.sections.app.header}<br></br>{lang.home.sections.app.header2}</h1>
                          <p>{lang.home.sections.app.copy}</p>
                          </Row>

                          <Row center="xs" start="sm"> 
                            <Col xs={6} sm={5}>
                              <a onClick={()=>this.props.dispatch(toggleInterstitial(true, lang.home.sections.app.cta1.src ))} className="appBtn hvr-pop">
                                <img src={lang.home.sections.app.cta1.img} alt={lang.home.sections.app.cta1.alt}></img>
                              </a>
                            </Col>
                            
                            <Col xs={6} sm={5}>
                              <a onClick={()=>this.props.dispatch(toggleInterstitial(true, lang.home.sections.app.cta2.src ))} className="appBtn hvr-pop">
                                <img src={lang.home.sections.app.cta2.img} alt={lang.home.sections.app.cta2.alt}></img>
                              </a>
                            </Col>

                          </Row>

                      </Col>
                      <Col lg={8}  className="app__Img">
                        <Caro
                            slideIndex={0}
                            respSlidesToShow={1}
                            slidesToShow={1}
                            slidesToScroll={1}
                            frameOverflow={true}
                            insertClass={"caro--app"}
                            initialWidth={300}
                            // framePadding={0}
                        >
                            {lang.home.sections.app.carousel.map((item, index) => (
                              <div key={`appitem__${index}`} className="caro__item" >

                                  {index === 0 &&( <img
                                    className="caro__img__static"
                                    src={item[this.state.appCaroItem]}
                                    alt={item.alt}
                                    onClick={()=>item.cta ? this.toggleModal(item.cta.src) : ''}
                                  ></img>)}
                                 {index > 0 &&( <img
                                    className="caro__img__static"
                                    src={item.img}
                                    alt={item.alt}
                                    onClick={()=>item.cta ? this.toggleModal(item.cta.src) : ''}
                                  ></img>)}
                              </div>
                            ))}
                        </Caro>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Grid>

            </div>
          )}
          
          <div className={`bottomAnchor train ${this.state.pastFold ? 'train--show' : '' }`}>
            <div className="train__tracks" style={{'backgroundImage': `url(${cdnBase}scroll/track.png)`}}></div> 
            {/* ${this.state.trainflip ? 'scaleX(-1)': ''} */}
            <div className={`train__train ${this.state.trainflip ? 'train__train--flip' : ''}`} style={{'transform': `translateX(${this.state.trainScrollPercent}px)`}}>
              <img src={`${cdnBase}scroll/nate-profile.png`} alt={'nate'}></img>
            </div>
            {this.state.trainProps && this.state.trainProps.length > 0 &&(
              <div className="train__props" style={{'transform': `translateX(-${this.state.propsScrollPercent}px)`}}>
  
                {this.state.trainProps.map((group,groupindex)=>(
                  <div className="train__props__group" key={`propgroup__${groupindex}`}>
                    {group.props.map((prop,index)=>(
                      // ${prop.type ? `train__props__prop--${prop.type}` : ``}
                      <div className={`train__props__prop ${prop.type ? `train__props__prop--${prop.type}` : ``}`}  key={`prop__${prop.id}`} id={`prop__${prop.id}`}>
                        {prop.animated && (
                          <Spritesheet
                            image={prop.sheet}
                            widthFrame={prop.widthFrame}
                            heightFrame={prop.heightFrame}
                            steps={prop.steps}
                            fps={prop.fps}
                            loop={true}
                            autoplay={false}
        
                            getInstance={spritesheet => {
                              this.spriteInstance(spritesheet,groupindex,index)
                            }}
    
                          />
                        )}
                        {!prop.animated && (
                          <div className="train__props__prop__img" style={{'backgroundImage': `url(${prop.sheet})`} } ></div>
                        )}
                        
                      </div>
                    ))}
                    
                  </div>
                ))}
              </div>
            )}
            

          </div>
        </div>
        
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { 
    lang: state.lang,
    currentAudio: state.activeAudio,
    gaToggle: state.gaToggle

  };
}

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/Pages/Home/Home.js